// extracted by mini-css-extract-plugin
export default {"sharing-filter-dropdown":"WorkflowSharingFilter_sharing-filter-dropdown__YV-0X","selected-user-dropdown":"WorkflowSharingFilter_selected-user-dropdown__F-NGN"};